module.exports = __webpack_public_path__ + "static/9-efdcbe2c55d2935f27654a4ec46cb3dc.jpg";